import { APP_PERMISSIONS } from '@exam-center/permission';
import { AddIcon, Button, type ButtonProps } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';

import { AssignExamCourseModal } from '../assign-exam-course-modal';

type AssignExamCourseButtonProps = Pick<ButtonProps, 'variant' | 'size'>;

export default function AssignExamCourseButton(props: Readonly<AssignExamCourseButtonProps>) {
  const { variant = 'contained', size = 'medium' } = props;

  const [isOpen, assignExamCourseModalHandlers] = useDisclosure();
  const { open: openAssignExamCourseModal, close: closeAssignExamCourseModal } =
    assignExamCourseModalHandlers;

  return (
    <WithPermission
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_COURSE.CREATE}
    >
      <Button
        size={size}
        variant={variant}
        startIcon={<AddIcon />}
        onClick={openAssignExamCourseModal}
      >
        เพิ่มหลักสูตร
      </Button>
      <AssignExamCourseModal open={isOpen} onClose={closeAssignExamCourseModal} />
    </WithPermission>
  );
}
